export class ResourceIdentifier 
{
	protected path: string[] = [];

	protected screen: string = null;
	public static readonly Shared = "ScreenAll";

	/** string representation of path */
	protected id: string = "";

	/** same as id, but dot prefix for css class notation, with separator in between */
	protected scope: string = "";

	/** same as id, but it contans separator at the end*/
	protected idScopedResourceName: string = "";

	public static readonly separator: string = "-";
    public static readonly scopeprefix: string = ".";
    
    public static readonly Global: ResourceIdentifier = new ResourceIdentifier(ResourceIdentifier.Shared, "GameAny");

	public constructor(screen: string, resid: string | string[]) {


		this.screen = screen;

		// keep track of path array
		if (typeof resid == "string") {
			this.path.push(resid);
		}
		else {
			for (let i = 0; i < resid.length; i++) {
				this.path.push(resid[i]);
			}
		}

		// generate string id
		this.id = this.screen + ResourceIdentifier.separator + this.path.join(ResourceIdentifier.separator);
		this.idScopedResourceName = this.id + ResourceIdentifier.separator;

		// generate string "scope"
		this.scope = ResourceIdentifier.scopeprefix + this.id;
	}

	/** Add another part to the id path */
	public Add(resid: string | string[]): ResourceIdentifier {
		// copy array and add new step
		let newpath: string[] = [];
		for (let i = 0; i < this.path.length; i++) {
			newpath.push(this.path[i]);
		}

		if (typeof(resid) == "string")
		{
			newpath.push(resid);
		}
		else
		{
			for (let i = 0; i < resid.length; i++)
			{
				newpath.push(resid[i]);
			}
		}

		return new ResourceIdentifier(this.screen, newpath);
	}

	/** id only */
	public ID(): string{
		return this.id;
	}

	/** same as id */
	public Scope(): string {
		return this.id;
	}

	/** prefixed with "." for css class */
	public CSSScope(): string {
		return this.scope;
	}



	/** same as id, with separator at the end */
	public ScopedResourceName(name: string | string[] = null) {
		if (name) {
			if (typeof name == "string")
				return this.idScopedResourceName + name;
			else {
				return this.idScopedResourceName + name.join(ResourceIdentifier.separator);
			}
		}

		return this.idScopedResourceName;
	}

	public Shared(): ResourceIdentifier
	{
		return new ResourceIdentifier(ResourceIdentifier.Shared, [...this.path]);
	}
}